export const SET_FIRST_FILTER = "SET_FIRST_FILTER";
export const SET_SECOND_FILTER = "SET_SECOND_FILTER";
export const TOGGLE_COMPARISON_FILTER = "TOGGLE_COMPARISON_FILTER";
